import type { ReactNode } from 'react';

import { cn } from '@/ui/utils/classnames';
import type { SwapFormVariant } from '../types.js';

type ToLayoutProps = {
  variant: SwapFormVariant;
  header: ReactNode;
  children: ReactNode;
};

function ToLayout({ variant, header, children }: ToLayoutProps) {
  const isHorizontal = variant === 'horizontal';
  const isVertical = variant === 'vertical';

  return (
    <>
      <div
        className={cn(
          'flex gap-x-2',
          isHorizontal && 'col-start-3 row-start-1 px-6',
          isVertical && 'col-span-2 col-start-1 row-start-4 px-6',
        )}
      >
        {header}
      </div>

      <div
        className={cn(
          'gap-x-2 px-6',
          isHorizontal &&
            'col-start-3 row-start-2 grid grid-cols-[auto_1fr] grid-rows-[auto_auto] justify-self-end',
          isVertical && 'col-span-2 col-start-1 row-start-5 flex',
        )}
      >
        {children}
      </div>
    </>
  );
}

export default ToLayout;
